"use client";

import { c as _c } from "react-compiler-runtime";
import { useEffect } from "react";
import type { CameraErrorKind } from "@/features/camera/useCameraSession";
type UseResetOnCameraErrorOptions = {
  errorKind: CameraErrorKind | null;
  onReset: () => void;
};
export function useResetOnCameraError(t0) {
  const $ = _c(4);
  const {
    errorKind,
    onReset
  } = t0;
  let t1;
  let t2;
  if ($[0] !== errorKind || $[1] !== onReset) {
    t1 = () => {
      if (errorKind === null) {
        return;
      }
      onReset();
    };
    t2 = [errorKind, onReset];
    $[0] = errorKind;
    $[1] = onReset;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
}